<template>
	<div class="workExamples" ref="work">
		<h2 class = 'mt-3'>Examples of how our skills can be applied </h2>
		<p class = 'lead'>
			To give you an idea of what we can achieve to help you, here are some selected publications where we contributed in method development and/or analysis.
		</p>
		<div class = "row" ref="examples">
			<div class = "col-12 col-sm-3">
				<ul class="nav nav-tabs nav-justified nav flex-column">
					<li class="nav-item" v-for="(label,link) in categories" :key="link">
						<a class="nav-link nav-category" :class="isActive(link)" @click="setCategory(link)">{{label}}</a>
					</li>
				</ul>
			</div>
			<div class = "col-12 col-sm-9">
				<div class = 'row' v-if="!activeProject">
					<div class="col-md-6 col-12" v-for="(project,pidx) in projectList" :key="pidx">

						<div class="card mb-3 project-summary" style="max-width: 540px;" @click="setProject(project)">
							<div class="row no-gutters">
								<div class="d-none d-md-block col-md-4 p-1">
									<img :src = "require(`@/assets/${project.thumbnail}`)" class="card-img" :alt="project.title">
								</div>
								<div class="col-md-8 col-sm-12">
									<div class="card-body">
										<h5 class="card-title project-title">{{project.title}}</h5>
										<p class="card-text"><small class="text-muted">click to learn more...</small></p>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
				<div v-if="activeProject">
					<div class = "card">
						<div class = "card-header">{{activeProject.title}}<span class = "float-right close" @click="activeProject=null">x</span></div>
						<div class = "card-body">
							<p class = "card-text" v-for="(url,uidx) in activeProject.publications" :key="uidx" ><a :href="url" target="_blank">{{url}}</a></p>
							<p class = "card-text">{{activeProject.description}}</p>

							<img :src = "require(`@/assets/${activeProject.image}`)" style="width: 100%">
						</div>
						<div v-if="activeProject.url" class="card-footer">
							<p><a :href="activeProject.url" target="_blank">{{activeProject.url}}</a></p>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import projects from '@/assets/projectExamples'
export default {
	name: 'workExamples',
	data () {
		return {
			categories: {
				genomics: "Genomics",
				facs: "Flow Cytometry",
				signal: "Signal processing",
				image: "Image analysis",
				structure: "Protein structure analysis",
				web: "Web-tool data visualisation"
			},
			activeCategory: 'genomics',
			activeProject: null,
			projects: projects
		}
	},
	computed: {
		projectList () {
			let _this = this
			return _.filter(this.projects, p => p.categories.indexOf(_this.activeCategory) > -1)
		}
	},
	methods: {
		isActive (cat) {
			return (cat === this.activeCategory) ? "active" : ""
		},
		setCategory (cat) {
			let _this = this;
			this.activeCategory = cat
			this.activeProject = null
			let projects = _.filter(this.projects, p => p.categories.indexOf(_this.activeCategory) > -1)
			if (projects.length === 1) this.activeProject = projects[0]
			let element = this.$refs['examples']
			this.$scrollTo(element, 250)
		},
		setProject (project) {
			this.activeProject = project
			let element = this.$refs['examples']
			this.$scrollTo(element, 250)

		}
	}
}
</script>

<style scoped>
span.close { 
	cursor: pointer;
}
a.nav-link {
	cursor: pointer;
}
div.project-summary {
	cursor: pointer;
}
h5.project-title, a.nav-category {
	text-transform: capitalize;
}
</style>